const actions = {
  async getCountries ({ commit }) {
    const countries = await window.axios.get('/countries')

    commit('ALL_COUNTRIES', countries.data)
  },

  async getCommunicationMethods ({ commit }) {

    const response = await window.axios.get('/communication-methods')

    commit('ALL_COMMUNICATION_METHODS', response.data)
  },

  async getAccount ({ commit }) {
    const response = await window.axios.get('/accounts/show')

    if (!response.data.address) {
      response.data.address = { country: null, city: null, street: null }
    }

    commit('ACCOUNT', response.data)
  },

  async updateAccount ({ commit }, payload) {

    const fd = new FormData()

    fd.append('id', payload.account.id)

    fd.append('sectionName', payload.sectionName)

    if (payload.taxCard) {
      fd.append('taxCard', payload.taxCard)
    }

    if (payload.commercial_registration) {
      fd.append('commercial_registration', payload.commercial_registration)
    }


    fd.append('account', JSON.stringify(payload.account))

    const response = await window.axios('/accounts/update', {
      method: 'POST',
      data: fd,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    if (!response.address) {
      response.data.address = { country: null, city: null, street: null }
    }

    commit('ACCOUNT', response.data)
    commit('authentication/SET_ACTIVE_ACCOUNT', response.data, { root: true })
  },

  async members ({ commit }) {
    const response = await window.axios.get('/accounts/members')

    commit('MEMBER_ACCOUNTS', response.data)
  },


  async acceptedAccounts ({ commit }) {
    const response = await window.axios.get('/accounts/accepted')

    commit('ACCEPTED_ACCOUNTS', response.data)
  },

  async getInvitations ({ commit }, payload) {
    const res =  await window.axios('/users/invitations', {params: payload})

    commit('ACCOUNT_USERS', res.data)

    return res
  },

  reSendInvitations (vuex, { id }) {
    return window.axios.post(`/invitations/resend/${id}`)
  },

  async getManagers ({ commit }) {
    const response = await window.axios.get('/users/managers')

    commit('ACCOUNT_MANAGERS', response.data)
  }
}

export default actions
